let pull = require('./lib/pull');
let callNewsAPP = require('./lib/callNewsAPP');

module.exports = {
    pull: pull,
    callNewsAPP: callNewsAPP
};



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.pullup/app/index.js